export default {
  title: 'Achievements',
};
